import { Injectable } from '@angular/core';
import { MainMenuItem } from '../interfaces/menu.interface';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  getMenu(code: string): MainMenuItem {
    return require(`../../assets/data/programs/${code}/main_menu.json`);
  }

  getAvailableMenus(programCode: string, restrictedMenus: string[]) {
    const menu = this.getMenu(programCode);
    return this.filterMenuItems(menu, restrictedMenus);
  }

  filterMenuItems = (menu: MainMenuItem, restrictedMenus: string[]) => {
    // Iterate through the categories in the menu and filter the items within each category
    const filteredMenuItems = Object.keys(menu).reduce((acc, category) => {
      // Filter the menu items for the current category
      const categoryItems = menu[category].filter((menuItem) => {
        // Check if the menu item is visible (display === "y")
        if (menuItem.display !== "y") return false;
  
        // Check if the menu item is in the restricted menus
        if (restrictedMenus.includes(menuItem.menu_id)) return false;
  
        // If both checks pass, include the menu item
        return true;
      });
  
      // Only include categories that have valid menu items
      if (categoryItems.length > 0) {
        acc[category] = categoryItems;
      }
  
      return acc;
    }, {} as MainMenuItem); // Initialize the accumulator as MainMenuItem
  
    return filteredMenuItems;
  };
}